import {ComponentType, useEffect, useState} from "react"
import {LoadingPage} from "@indebted/components/Loading"
import {ErrorPage} from "@indebted/components/Error"
import {loadStripe, type Stripe} from "@stripe/stripe-js"
import {useAnalytics} from "@indebted/analytics"

const errorTitle = "Failed contacting payment provider"
const errorMessage = (
	<>
		We apologize for the inconvenience.
		<br />
		Please try again.
	</>
)

function withStripe(Component: ComponentType<any>, betas: string[] = []) {
	return function WithStripe({publishableKey, ...props}) {
		const [stripe, setStripe] = useState<Stripe | null>(null)
		const [error, setError] = useState<Error | null>(null)
		const {track} = useAnalytics()

		useEffect(() => {
			loadStripe(publishableKey, {betas})
				.then((stripe) => {
					setStripe(stripe)
				})
				.catch((error) => {
					setError(error)
					console.error("Failed loading Stripe client", error)
				})
		}, [publishableKey])

		useEffect(() => {
			if (error) {
				track("FailedLoadingStripe", error)
			}
		}, [error, track])

		if (error) {
			return <ErrorPage message={errorMessage} title={errorTitle} error={error} />
		}

		if (!stripe) {
			return <LoadingPage />
		}

		return <Component stripe={stripe} {...props} />
	}
}

export {withStripe}
